import * as React from 'react';
import { Book as BookType } from '../../types/Book';
import cn from 'classnames';
import './Book.css';

interface Props {
	book: BookType;
	disabled?: boolean;
	onClick?: (book: BookType) => void;
	type?: 'row' | 'standart' | 'mini';
	payload?: React.ReactNode;
	className?: string;
	clickable?: boolean;
}

const Book: React.FunctionComponent<Props> = ({ book, className, type, onClick, disabled, payload, clickable }) => {
	return <div
		className={
			cn("book", {
				'book_standart': type === 'standart',
				'book_mini': type === 'mini'
			}, className)
		}
		onClick={!disabled ? onClick ? () => onClick(book) : () => { 
			window.location.href = `book/${book.externalId}`;
		} : null}
	>
		<div className="book__image">
			<img src={book.image}/>
		</div>

		<div className="book__details">
			<div className="book__header">
				{clickable ? <a href={`/book/${book.woo_id ? book.woo_id : `t${book.externalId}`}/`}>
					{book.name}
				</a> : book.name}
			</div>

			<div className="book__author">
				{book.author}
			</div>

			{payload && <div className="book__payload">
				{payload}	
			</div>}
		</div>
	</div>
};

export default Book;
